<template>
    <div class="container">
        <el-tag type="success" size="mini">总计
            <el-badge class="mark" :value="user_key_list.length"/>
        </el-tag>
        &nbsp;&nbsp;
        <el-button type="text" size="mini" @click="addKey"
        >添加新的key
        </el-button>&nbsp;&nbsp;
        <el-button type="text" size="mini" @click="getKey"
        >获取可用key
        </el-button>
        <div class="wrapper">
            <el-table
                    :height="tableHight"
                    :border="true"
                    :data="user_key_list"
                    class="left">
                <el-table-column
                        align="center"
                        header-align="center"
                        prop="user_key"
                        label="user_key"
                        width="200">
                </el-table-column>
                <el-table-column
                        align="center"
                        header-align="center"
                        label="类别"
                        width="100">
                    <template slot-scope="scope">
                        <el-tag size="mini" type="success" v-if="scope.row.type === 'production'">生产</el-tag>
                        <el-tag type="warning" size="mini" v-else>测试</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        header-align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <span>
                            <el-button
                                    type="text"
                                    size="mini"
                                    @click="viewDetails(scope.row)"
                            >详情
                            </el-button>
                                                        <el-button type="text" size="mini"
                                                                   @click="viewConnectionRecord(scope.row)">连接记录</el-button>

                            <el-button type="text" size="mini" @click="deleteKey(scope.row.user_key)"
                                       class="danger-text">删除
                            </el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="right" v-if="rightWrapperShow" v-loading="loading">
                <h3 class="sub-header">
                    {{this.actived_item}}接口统计&nbsp;&nbsp;&nbsp;
                </h3>
                <dateRangePicker @change="handleChange"></dateRangePicker>
                <el-table
                        :data="api_count_map_new"
                        style="width: 100%">

                    <el-table-column
                            label="API"
                            prop="desc"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            label="COUNT"
                            prop="count"
                    >
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            label="操作"
                    >
                        <template slot-scope="scope">
                            <el-button v-show="!scope.row.noBtn"
                                       type="primary" size="mini" @click="viewApiRecord(scope.row)">调用记录
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
  import {apiGetUserKey, apiDeleteUserKey, apiAddNewUserKey, apiGetAvailableKey, apiGetApiCount} from "@/api";
  import vvTable from "vue-virtual-table";
  import dateRangePicker from "./dateRangePicker";
  import _ from "lodash";

  export default {
    name: 'userKey',
    components: {
      dateRangePicker
    },
    data() {
      return {
        loading: false,
        rightWrapperShow: false,
        user_key_list: [],
        api_count_map: null,
        actived_item: null,
        dateRangeTs: null,
        price: 0
      }
    },
    mounted() {
      this.getUserKey()
    },
    methods: {
      viewConnectionRecord(row) {
        console.log(row);
        this.$router.push({
          name: 'connectionRecords',
          props: true,
          params: {
            user_key: row.user_key,
            dateRangeTs: this.dateRangeTs
          }
        })
      },
      viewApiRecord(row) {
        this.$router.push({
          name: 'apiRecords',
          props: true,
          params: {
            user_key: row.key,
            dateRangeTs: this.dateRangeTs
          }
        })
      },
      handleChange(obj) {
        this.dateRangeTs = obj
        this.getApiCount()
      },
      viewDetails({user_key}) {
        this.actived_item = user_key
        this.rightWrapperShow = true
        this.getApiCount()
      },
      async getKey() {
        this.$confirm('请选择user_key的使用环境', '提示', {
          confirmButtonText: "生产环境",
          cancelButtonText: '测试环境',
          distinguishCancelAndClose: true
        }).then(res => {
          this.getAvailableKey('production');
        }).catch(e => {
          if (e === 'cancel') {
            this.getAvailableKey('test');
          }
        });
      },
      async getAvailableKey(type) {
        try {
          const {available_user_key} = await apiGetAvailableKey({
            attr: type
          });
          // console.log(res);
          this.$alert(available_user_key, `${type === 'test' ? '测试环境' : '生产环境'}可用key`, {
            confirmButtonText: '复制该key',
            distinguishCancelAndClose: true,
            callback: action => {
              if (action === 'close') return
              this.$copyText(available_user_key)
                .then(e => {
                  this.$message.success('复制成功');
                })
                .catch(e => {
                  this.console.log(e);
                  this.$message.error('复制失败' + e);
                });
            }
          });
        } catch (e) {
          this.$message.error('获取失败');
        }
      },
      async deleteKey(userKey) {
        try {
          await apiDeleteUserKey(userKey);
          this.$message.success("删除成功");
          this.getUserKey();
        } catch (e) {
          this.$message.error('删除失败' + e.message);
          console.log(e);
        }
      },
      async addKey() {
        this.$confirm('请选择user_key的使用环境', '提示', {
          confirmButtonText: "生产环境",
          cancelButtonText: '测试环境',
          distinguishCancelAndClose: true
        }).then(res => {
          this.confirmAddKey('production');
        }).catch(e => {
          if (e === 'cancel') {
            this.confirmAddKey('test');
          }
        });
      },
      async getApiCount() {
        let user_key = this.actived_item
        this.loading = true
        try {
          this.api_count_map = null;
          this.price = 1
          const {api_count_map, price} = await apiGetApiCount({
            user_key,
            start_time: this.dateRangeTs.start_time,
            end_time: this.dateRangeTs.end_time
          });
          // return {
          //   d: Number(api_count_map[`${key}_d`]),
          //   f: Number(api_count_map[`${key}_f`]),
          //   r: Number(api_count_map[`${key}_r`])
          // };
          this.api_count_map = api_count_map
          this.price = price
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      },
      async confirmAddKey(type) {
        try {
          const res = await apiAddNewUserKey({
            attr: type
          });
          // this.$message.success('添加成功');
          this.getUserKey();

          this.$alert(res.user_key, `新添加的${type === 'test' ? '测试环境' : '生产环境'} user_key`, {
            confirmButtonText: '复制该key',
            callback: action => {
              if (action === 'close') return
              this.$copyText(res.user_key)
                .then(e => {
                  this.$message.success('复制成功');
                })
                .catch(e => {
                  this.console.log(e);
                  this.$message.error('复制失败' + e);
                });
            }
          });
        } catch (e) {
          console.log(e);
          this.$message.error('添加失败');
        }
      },
      async getUserKey() {
        try {
          const {user_key_list, user_key_dic} = await apiGetUserKey();
          // console.log(user_key_list);
          this.user_key_list = user_key_list.map(user_key => {
            return {
              user_key,
              type: user_key_dic[user_key].attr
            }
          });
          // return user_key_list;
        } catch (e) {
          console.log(e);
        }
      }
    },
    computed: {
      api_count_map_new() {
        let api_count_map = this.api_count_map;
        if (api_count_map === null) {
          return;
        }
        let sum = 0;
        // let {sedexo_d: d, sodexo_e: e, sedexo_f: f} = res.data.data
        let new_api_count_map = Object.keys(api_count_map).map(key => {
          let desc = "";
          let name = _.last(key.split("_"));
          console.log(name);
          switch (name) {
            case "d":
              desc = "dish region";
              break;
            case "f":
              desc = "food feature";
              break;
            case "r":
              desc = "food retrieve";
              break;
            default:
              break;
          }
          sum += Number(api_count_map[key]);
          return {
            key,
            name,
            desc,
            count: api_count_map[key]
          };
        });
        new_api_count_map.push({
          desc: "Total",
          noBtn: true,
          count: sum,
          name: "total"
        });
        new_api_count_map.push({
          desc: "费用",
          noBtn: true,
          count: this.price,
          name: "price"
        });

        return new_api_count_map;
      },

      tableHight() {
        const clientHeight = window.innerHeight;
        return clientHeight - 120;
      },
      tableConfig1() {
        return [
          {prop: "user_key", name: "user_key", width: 100},
          {prop: "_action", name: "类别", width: 100, actionName: '_type'},
          {
            prop: "_action",
            name: "操作",
            width: 150,
            actionName: "_event"
          }
        ];
      }
    },
    watch: {}
  }
</script>
<style lang="scss" scoped>
    .container {
        .wrapper {
            display: flex;

            .left {
                width: 500px;
                flex: 0 0 500px;
            }

            .right {
                padding-left: 20px;
                flex: 1;

                .sub-header {
                    display: inline-block;
                }
            }
        }
    }
</style>
